
const fontColor = "blue";

const components = {
    // Name of the component
    MuiToggleButtonGroup: {
        // defaultProps : {
        //     marginLeft : '0px'
        // },
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          "marginLeft": '0px !important',
        },
      },
    },

    // MuiListItemText : {
    //   styleOverrides: {
    //     // Name of the slot
    //     root: {
    //       // Some CSS
    //       color : fontColor,
    //     },
    //   },
    // },

    // MuiTypography : {
    //   styleOverrides: {
    //     // Name of the slot
    //     root: {
    //       // Some CSS
    //       color : fontColor,
    //     },
    //   },
    // },


};



export default components;